import Vue from "vue";
// import router from "./router"
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/case",
    name: "Case",
    component: () =>
      import("../views/Case.vue")
  },
  {
    path: "/casedetail",
    name: "CaseDetail",
    component: () =>
      import("../views/CaseDetail.vue")
  },
  {
    path: "/product",
    name: "Product",
    component: () =>
      import("../views/Product.vue")
  },
  {
    path: "/productTab",
    name: "ProductTab",
    component: () =>
      import("../views/ProductTab.vue")
  },
  {
    path: "/productTwoTab",
    name: "ProductTwoTab",
    component: () =>
      import("../views/ProductTwoTab.vue")
  },
  {
    path: "/productTabDetail",
    name: "ProductTabDetail",
    component: () =>
      import("../views/ProductTabDetail.vue")
  },
  {
    path: "/customized",
    name: "Customized",
    component: () =>
      import("../views/Customized.vue")
  },
  {
    path: "/dzfw",
    name: "Dzfw",
    component: () =>
      import("../views/dzfw.vue")
  },
  {
    path: "/yfxq",
    name: "Yfxq",
    component: () =>
      import("../views/yfxq.vue")
  },
  {
    path: "/azgd",
    name: "Azgd",
    component: () =>
      import("../views/azgd.vue")
  },
  {
    path: "/journalism",
    name: "Journalism",
    component: () =>
      import("../views/Journalism.vue")
  },
  {
    path: "/JournalismDetail",
    name: "JournalismDetail",
    component: () =>
      import("../views/JournalismDetail.vue")
  },
  {
    path: "/aboutUs",
    name: "AboutUs",
    component: () =>
      import("../views/AboutUs.vue")
  },
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  // console.log(window.navigator.userAgent)
  if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|Windows; U; Windows NT)/i)) {
    window.location.href = `${window.location.origin}/Wap/${window.location.hash}`
  } else {
    next()
  }
});

export default router;
